import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  useGetBannerbyIdQuery,
  useUpdateBannerMutation,
} from "../../../../Services/HomeAPI";
import { useNavigate, useParams } from "react-router-dom";

function AddCategory() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [isActive, setIsActive] = useState(1);
  const [buttonText, setButtonText] = useState("");
  const [buttonIsActive, setButtonIsActive] = useState(1);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [buttonURL, setButtonURL] = useState("");
  const [updateBanner, { isLoading }] = useUpdateBannerMutation();
  const {
    data: bannerDetail,
    isLoading: loadingContent,
    error,
    refetch: refetchBannerDetail,
  } = useGetBannerbyIdQuery(id);

  useEffect(() => {
    refetchBannerDetail();
  }, [refetchBannerDetail]);

  useEffect(() => {
    setTitle(bannerDetail?.title);
    setDescription(bannerDetail?.description);
    setIsActive(bannerDetail?.is_active);
    setButtonIsActive(bannerDetail?.button_is_active);
    setButtonText(bannerDetail?.button_text);
    setButtonURL(bannerDetail?.button_url);
    console.log("bannerDetail", bannerDetail);
  }, [bannerDetail]);

  const validateForm = () => {
    let newErrors = {};
    if (!title.trim()) newErrors.title = "Title is required";
    if (!description.trim()) newErrors.description = "Description is required";

    if (!buttonText.trim()) newErrors.buttonText = "Button text is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    if (image) {
      formData.append("image", image);
    }

    formData.append("is_active", isActive);
    formData.append("button_text", buttonText);
    formData.append("button_url", buttonURL);
    formData.append("button_is_active", buttonIsActive);

    try {
      await updateBanner({ formData, id }).unwrap();
      alert("Banner updated successfully!");
      setTitle("");
      setDescription("");
      setImage(null);
      setIsActive(1);
      setButtonText("");
      setButtonIsActive(1);
      setErrors({});
      setApiError(null);
      navigate("/home-banner-list");
    } catch (error) {
      setApiError(error.data?.message || "Something went wrong");
    }
  };

  if (loadingContent) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>Edit Banner</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/home-banner-list">
            <span>Banner</span>
          </Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">Edit</span>
        </p>
      </div>
      <div className="content-wrapper">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="col-md-6">
            <div className="mb-4 text-start">
              <div className="d-flex gap-3">
                <label>
                  <input
                    type="radio"
                    name="isActive"
                    value={1}
                    checked={isActive === 1}
                    onChange={() => setIsActive(1)}
                  /> Show
                </label>
                <label>
                  <input
                    type="radio"
                    name="isActive"
                    value={0}
                    checked={isActive === 0}
                    onChange={() => setIsActive(0)}
                  /> Hide
                </label>
                <div className="tooltip-container">
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="text-warning mx-2"
                    style={{ cursor: "pointer" }}
                  />
                  <div className="tooltip">Show/Hide the Banner section</div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-12">
              <div className="mb-4 text-start">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {errors.title && <p className="text-danger">{errors.title}</p>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Button Label  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Button Text</div>
                  </div></label>
                <input
                  type="text"
                  className="form-control"
                  value={buttonText}
                  onChange={(e) => setButtonText(e.target.value)}
                />
                {errors.buttonText && (
                  <p className="text-danger">{errors.buttonText}</p>
                )}
              </div>
            </div>

            <div className="col-md-6 d-flex align-center">
              <div className="mb-4 text-start">
                <div className="d-flex gap-3">
                  <label>
                    <input
                      type="radio"
                      name="buttonIsActive"
                      value={1}
                      checked={buttonIsActive === 1}
                      onChange={() => setButtonIsActive(1)}
                    /> Show
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="buttonIsActive"
                      value={0}
                      checked={buttonIsActive === 0}
                      onChange={() => setButtonIsActive(0)}
                    /> Hide
                  </label>
                  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Enable/Disable the button</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Button URL  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">Link to the corresponding page</div>
                  </div></label>
                <input
                  type="url"
                  className="form-control"
                  value={buttonURL}
                  onChange={(e) => setButtonURL(e.target.value)}
                />
                {errors.buttonURL && (
                  <p className="text-danger">{errors.buttonURL}</p>
                )}
              </div>
            </div>




            <div className="col-md-12">
              <div className="mb-4 text-start">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {errors.description && (
                  <p className="text-danger">{errors.description}</p>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                />
                {errors.image && <p className="text-danger">{errors.image}</p>}
                <img
                  src={bannerDetail?.desktop_image_url}
                  alt="banner-img"
                  width={200}
                  height={200}
                />
              </div>
            </div>
          </div>
          {apiError && <p className="text-danger text-center">{apiError}</p>}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
